export default "__VITE_ASSET__Blyr$qpS__"